import * as React from 'react';
import DatePicker from "react-datepicker";
import { Col, FormFeedback, FormGroup, Input, Label, Row } from 'reactstrap';
import { useAppSelector } from '../../hooks';
import {
    Entity,
    selectedEntity
} from '../../redux/EntitySlice';
import dateHelper from '../../utils/dateHelper';



const ReportAccessEnabler = (props: any) => {

    const entitySelector: Entity | undefined = useAppSelector(selectedEntity);

    //enablement checkbox hooks
    const [afrEnabled, setAfrEnabled] = React.useState<boolean>(false);
    const [courtReporting939Enabled, setCourtReporting939Enabled] = React.useState<boolean>(false);
    const [courtReporting29Enabled, setCourtReporting29Enabled] = React.useState<boolean>(false);

    //date hooks
    const [afrReportAccessDate, setAfrReportAccessDate] = React.useState<any>(null);
    const [nineThirtyNineReportAccessDate, setNineThirtyNineReportAccessDate] = React.useState<any>(null);
    const [twentyNineReportAccessDate, setTwentyNineReportAccessDate] = React.useState<any>(null);


    //todo source this from graphql query
    const reportTypes: Array<string> = ['AFR_ENABLED', 'COURT_REPORTING_939_ENABLED', 'COURT_REPORTING_29_ENABLED'];

    const handleReportAccessChange = (checked: boolean, reportAccessName: string) => {

        switch (reportAccessName) {

            case 'AFR_ENABLED':
                // setAfrEnabled(checked);
                props.setParentAfrEnabled(checked);
                break;

            case 'COURT_REPORTING_939_ENABLED':
                // setCourtReporting939Enabled(checked);
                props.setParentCourtReporting939Enabled(checked);
                break;

            case 'COURT_REPORTING_29_ENABLED':
                //setCourtReporting29Enabled(checked);
                props.setParentCourtReporting29Enabled(checked);
                break;

            default:
                break;
        }

    }

    const handleReportAccessDateChange = (date: any, reportAccessName: string) => {

        switch (reportAccessName) {

            case 'AFR_ENABLED':
                // setAfrReportAccessDate(date);
                props.setParentAfrReportAccessDate(date);
                break;

            case 'COURT_REPORTING_939_ENABLED':
                //setNineThirtyNineReportAccessDate(date);
                props.setParentNineThirtyNineReportAccessDate(date);
                break;

            case 'COURT_REPORTING_29_ENABLED':
                //setTwentyNineReportAccessDate(date);
                props.setParentTwentyNineReportAccessDate(date);
                break;

            default:
                break;
        }

    }

    function initReportAccessGivenValue(accessName: string) {
        if (entitySelector && entitySelector.entityReportAccessChanges) {
            var accessType = entitySelector.entityReportAccessChanges.find((ele) => ele.state == accessName);
            if (accessType) {
                var date = dateHelper.convertToDate(accessType.timestamp);

                switch (accessName) {

                    case 'AFR_ENABLED':
                        if (accessType !== undefined && accessType.value == "TRUE") {
                            setAfrEnabled(true);
                            props.setParentAfrEnabled(true);
                        } else {
                            setAfrEnabled(false);
                            props.setParentAfrEnabled(false);
                        }
                        if (date) {
                            setAfrReportAccessDate(date);
                            props.setParentAfrReportAccessDate(date);
                        }

                        break;

                    case 'COURT_REPORTING_939_ENABLED':
                        if (accessType !== undefined && accessType.value == "TRUE") {
                            setCourtReporting939Enabled(true);
                            props.setParentCourtReporting939Enabled(true);
                        } else {
                            setCourtReporting939Enabled(false)
                            props.setParentCourtReporting939Enabled(false)
                        }
                        if (date) {
                            setNineThirtyNineReportAccessDate(date);
                            props.setParentNineThirtyNineReportAccessDate(date);
                        }
                        break;

                    case 'COURT_REPORTING_29_ENABLED':
                        if (accessType !== undefined && accessType.value == "TRUE") {
                            setCourtReporting29Enabled(true);
                            props.setParentCourtReporting29Enabled(true);
                        } else {
                            setCourtReporting29Enabled(false);
                            props.setParentCourtReporting29Enabled(false);
                        }
                        if (date) {
                            setTwentyNineReportAccessDate(date);
                            props.setParentTwentyNineReportAccessDate(date);
                        }
                        break;

                    default:
                        break;
                }

            }

        }
    }

    function reportAccessHasChanged(): boolean {

        let result: boolean = afrEnabled != props.parentAfrEnabled
            || courtReporting29Enabled != props.parentCourtReporting29Enabled
            || courtReporting939Enabled != props.parentCourtReporting939Enabled

            || (dateHelper.areTwoDatePickerValuesEqual(afrReportAccessDate, props.parentAfrReportAccessDate) == false)
            || (dateHelper.areTwoDatePickerValuesEqual(nineThirtyNineReportAccessDate, props.parentNineThirtyNineReportAccessDate) == false)
            || (dateHelper.areTwoDatePickerValuesEqual(twentyNineReportAccessDate, props.parentTwentyNineReportAccessDate) == false);

        return result;
    }

    const initializeReportAccessesGivenEntity = () => {

        if (entitySelector && entitySelector.entityReportAccessChanges) {
            if (entitySelector.entityReportAccessChanges !== undefined) {
                if (entitySelector.entityReportAccessChanges.length > 0) {
                    for (var i = 0; i < reportTypes.length; i++) {
                        initReportAccessGivenValue((reportTypes[i]));
                    }
                }
            }
        }
    }

    React.useEffect(() => {

        setAfrEnabled(false);
        setCourtReporting939Enabled(false);
        setCourtReporting29Enabled(false);

        props.setParentAfrEnabled(false);
        props.setParentCourtReporting939Enabled(false);
        props.setParentCourtReporting29Enabled(false);

        setAfrReportAccessDate(null);
        setNineThirtyNineReportAccessDate(null);
        setTwentyNineReportAccessDate(null);

        props.setParentAfrReportAccessDate(null);
        props.setParentNineThirtyNineReportAccessDate(null);
        props.setParentTwentyNineReportAccessDate(null);

        initializeReportAccessesGivenEntity();

    }, [entitySelector])

    React.useEffect(() => {

        props.setParentReportAccessHasChanged(reportAccessHasChanged());

    }, [props.parentAfrEnabled,
    props.parentCourtReporting939Enabled,
    props.parentCourtReporting29Enabled,

    props.parentAfrReportAccessDate,
    props.parentNineThirtyNineReportAccessDate,
    props.parentTwentyNineReportAccessDate])

    return (
        <React.Fragment>
            {entitySelector ? (<React.Fragment>
                <FormGroup>
                    <FormGroup >
                        <Row>
                            <Col md="4" style={{ textAlign: "left" }}>
                                <Label>Report Access:</Label>
                            </Col>
                            <Col md="8" style={{ paddingLeft: "2em" }}>
                                <FormGroup>
                                    <Row>
                                        <Col>
                                            <Label check>
                                                <Input type="checkbox"
                                                    onChange={(e) => handleReportAccessChange(e.target.checked, "AFR_ENABLED")}
                                                    checked={props.parentAfrEnabled}
                                                />{' '}
                                                AFR
                                            </Label>
                                        </Col>
                                        <Col md="8">
                                            <DatePicker
                                                selected={props.parentAfrReportAccessDate}
                                                dateFormat="MM/dd/yyyy"
                                                onChange={(date: any) => handleReportAccessDateChange(date, "AFR_ENABLED")}
                                                maxDate={new Date()}
                                            />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <Input
                                                type="hidden"
                                                invalid={(afrEnabled != props.parentAfrEnabled)
                                                    && (props.parentAfrReportAccessDate == null)} />
                                            <FormFeedback>A date is required for the AFR report access change.</FormFeedback>
                                        </Col>
                                    </Row>
                                </FormGroup>

                                <FormGroup>
                                    <Row>
                                        <Col>
                                            <Label check>
                                                <Input type="checkbox"
                                                    checked={props.parentCourtReporting939Enabled}
                                                    onChange={(e) => handleReportAccessChange(e.target.checked, "COURT_REPORTING_939_ENABLED")} />{' '}
                                                939.185
                                            </Label>
                                        </Col>
                                        <Col md="8">
                                            <DatePicker
                                                selected={props.parentNineThirtyNineReportAccessDate}
                                                dateFormat="MM/dd/yyyy"
                                                onChange={(date: any) => handleReportAccessDateChange(date, "COURT_REPORTING_939_ENABLED")}
                                                maxDate={new Date()}
                                            />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <Input
                                                type="hidden"
                                                invalid={(courtReporting939Enabled != props.parentCourtReporting939Enabled)
                                                    && (props.parentNineThirtyNineReportAccessDate == null)} />
                                            <FormFeedback>A date is required for the 939.185 report access change.</FormFeedback>
                                        </Col>
                                    </Row>
                                </FormGroup>

                                <FormGroup>
                                    <Row>
                                        <Col>
                                            <Label check>
                                                <Input type="checkbox"
                                                    checked={props.parentCourtReporting29Enabled}
                                                    onChange={(e) => handleReportAccessChange(e.target.checked, "COURT_REPORTING_29_ENABLED")}
                                                />{' '}
                                                29.0085
                                            </Label>
                                        </Col>
                                        <Col md="8">
                                            <DatePicker
                                                selected={props.parentTwentyNineReportAccessDate}
                                                dateFormat="MM/dd/yyyy"
                                                onChange={(date: any) => handleReportAccessDateChange(date, "COURT_REPORTING_29_ENABLED")}
                                                maxDate={new Date()}
                                            />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <Input
                                                type="hidden"
                                                invalid={(courtReporting29Enabled != props.parentCourtReporting29Enabled)
                                                    && (props.parentTwentyNineReportAccessDate == null)} />
                                            <FormFeedback>A date is required for the 29.0085 report access change.</FormFeedback>
                                        </Col>
                                    </Row>
                                </FormGroup>

                            </Col>

                        </Row>
                    </FormGroup>
                </FormGroup>

            </React.Fragment>) : (<React.Fragment></React.Fragment>)}


        </React.Fragment>
    );
}

export default ReportAccessEnabler;


